export default function UnitedAmount({amount, unit}: { amount: number, unit: number }) {
    let mapping = [
        "g",
        "mL",
        "x",
        "?"
    ];

    return (
        <div className="text-8 font-medium">
            <span>{amount}</span>
            <span>{mapping[unit]}</span>
        </div>
    );
}